import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAi'

export const profilesList = (params = '') => Http.get(`/admin/profile-categories${serialize(params)}`)
export const profileCreate = (params = '') => Http.post('/admin/profile-categories', params)
export const profileByID = (params = '') => Http.get(`/admin/profile-categories${params}`)
export const profileUpdate = (params = '') => Http.put(`/admin/profile-categories/${params.id}`, params)
export const profileDestroy = (params = '') => Http.delete(`/admin/profile-categories/${params.id}`)
